import _ from 'underscore';
import $ from 'jquery';
import signals from 'signals';
import mustache from 'mustache';

/**
 * BaseView class for extending basic functionality to other view.
 */
class BaseView {

  /**
   * @constructor
   * @param {string} el, HTML element selector, element witch the view is goin to bind to
   * @param {object} dom, elements sub elements selectors as key value pairs.
   * @param {object} options, optional extra options
   */
  constructor(el, dom, options={}) {
    this.$el = $(el);

    if( options.template ) {
      this._template = $(options.template).html();
      this.$el.append( mustache.render( this._template ) );
    }

    this.bindDOM( dom );
    this.bind();
  }

  /**
   * Bind initial dom object elements to the view
   * @param {*} dom, dictionary <key, selector>
   */
  bindDOM( dom ) {
    this.dom = dom;
    this.$dom = {};
    _.each( dom, ( selector, key ) => {
      this.$dom[key] = this.$el.find( selector );
    }, this);
  }

  /**
   * Used to return data to the mustache template time of template render.
   * Like: Mustache.render( template, this.data() )
   */
  data() {}

  /**
   * Function is used to bind function to DOM elements actions, like
   * clicking the button or listening the text field. The function is
   * called by BaseView constructor.
   */
  bind() {}

  /**
   * Show or hide the view, just toggle d-none class.
   * @param {boolean} show, if true is passed then view is shown, otherwise it's being hidden.
   */
  show(show) {
    this.$el.toggleClass('d-none', !show);
  }

  /**
   * Return page language from the root html element.
   *
   * @return {string} language, defaults to 'en'
   */
  getPageLanguage() {
    var lang = $('html').attr('lang');
    return lang ? lang : 'en';
  }
}

/**
 * This exposes a way send signals from one view to antoher.
 * Every insance of BaseView class can listen and send these signals.
 *
 * #Evet emitter pattern
 *
 * More about signals: http://millermedeiros.github.io/js-signals/
 */
BaseView.prototype.signals = {
  signedin: new signals.Signal(),
  signedout: new signals.Signal()
}

export default { BaseView };
export { BaseView };
